import { useEffect } from 'react';

/**
 * AccessibilityFixer Component
 * 
 * Monitors and fixes accessibility issues that can occur with dynamic content,
 * specifically the aria-hidden attribute being incorrectly applied to the root element.
 */
const AccessibilityFixer = () => {
  useEffect(() => {
    // Function to remove aria-hidden from root element
    const fixRootAriaHidden = () => {
      const rootElement = document.getElementById('root');
      if (rootElement && rootElement.getAttribute('aria-hidden') === 'true') {
        console.log('🔧 Fixing aria-hidden on root element');
        rootElement.removeAttribute('aria-hidden');
      }
    };

    // Function to monitor for aria-hidden changes
    const monitorAriaHidden = () => {
      const rootElement = document.getElementById('root');
      if (!rootElement) return;

      // Create a MutationObserver to watch for attribute changes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
            const target = mutation.target;
            if (target.id === 'root' && target.getAttribute('aria-hidden') === 'true') {
              console.log('🔧 Detected aria-hidden=true on root, removing...');
              target.removeAttribute('aria-hidden');
            }
          }
        });
      });

      // Start observing
      observer.observe(rootElement, {
        attributes: true,
        attributeFilter: ['aria-hidden']
      });

      return observer;
    };

    // Initial fix
    fixRootAriaHidden();

    // Set up monitoring
    const observer = monitorAriaHidden();

    // Also check periodically as a fallback
    const intervalId = setInterval(fixRootAriaHidden, 1000);

    // Cleanup function
    return () => {
      if (observer) {
        observer.disconnect();
      }
      clearInterval(intervalId);
    };
  }, []);

  // This component doesn't render anything
  return null;
};

export default AccessibilityFixer; 